import moment from 'moment';
import { useEffect } from 'react';
import { Container, Modal } from 'react-bootstrap'

const LeaveModal = ({ showModal, setShowModal, employeeOnLeavesDate, employeeOnLeave }) => {
    useEffect(() => {
        let data = document.querySelector('.saperator');
        if(parseInt(data.children.length % 2) !== 0){
            data.lastChild.classList.remove('content-container');
            data.lastChild.classList.add('ms-2', 'content-container', 'ps-2');
        }
    })  
    return (
        <Modal show={showModal} size='md' className='bg-none' centered onHide={setShowModal} >
            <Modal.Header className='fw-bold' closeButton>
                Employees are on Leaves : {moment(employeeOnLeavesDate).format("DD-MM-YYYY")}
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-wrap justify-content-start saperator'>
                    {
                        employeeOnLeave.map((item, index) => (
                            JSON.parse(item.title).leaveDate === employeeOnLeavesDate &&
                            <Container className='content-container mt-2 p-2 border d-flex justify-content-between rounded-3' key={index}>
                                <div className='d-flex w-100 justify-content-between align-items-center'>
                                    <img src={JSON.parse(item.title).empImage} title={JSON.parse(item.title).employeeName} style={{ cursor : "pointer" , borderRadius : "30px" , border: JSON.parse(item.title).leaveType.toLowerCase() === 'full' ? "3px solid red" : "3px solid blue" }} />
                                    <div className='text-dark fw-bold w-75 text-end'>
                                        {JSON.parse(item.title).employeeName} <br/>
                                        {JSON.parse(item.title).leaveType.toUpperCase()}-DAY
                                    </div>
                                </div>
                            </Container>
                        ))
                    }
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default LeaveModal;